import { _ as m } from "./index.es463.js";
import { i as g } from "./index.es285.js";
import { i as _ } from "./index.es265.js";
import { i as h } from "./index.es266.js";
import { _ as y } from "./index.es464.js";
import { i as A } from "./index.es465.js";
var b = m, d = g, x = _, T = h, c = y, u = A, O = Object.prototype, B = O.hasOwnProperty;
function I(s, n) {
  var i = x(s), t = !i && d(s), e = !i && !t && T(s), a = !i && !t && !e && u(s), f = i || t || e || a, o = f ? b(s.length, String) : [], p = o.length;
  for (var r in s)
    (n || B.call(s, r)) && !(f && // Safari 9 has enumerable `arguments.length` in strict mode.
    (r == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    e && (r == "offset" || r == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (r == "buffer" || r == "byteLength" || r == "byteOffset") || // Skip index properties.
    c(r, p))) && o.push(r);
  return o;
}
var E = I;
export {
  E as _
};
//# sourceMappingURL=index.es406.js.map
